import { cn } from "../../lib/utils";
import { getDividerClass } from "../../styles/theme";

interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  isLightMode?: boolean;
}

function Divider({ className = "", isLightMode = false, ...props }: DividerProps) {
  return (
    <div
      className={cn("h-[0.05em] flex-grow", getDividerClass(isLightMode), className)}
      {...props}
    />
  );
}

export default Divider;
